module.exports = __webpack_public_path__ + "img/violet_137.ea3f1071.png";